import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/BrandLogo";

const UPDATED = "Νοέμβριος 2026";
const CONTACT = "privacy@nbacube.app";

function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="font-display text-xl font-bold text-slate-100 uppercase tracking-wide">{title}</h2>
      <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-300">{children}</div>
    </section>
  );
}

export default function Privacy() {
  return (
    <div className="min-h-screen court-grain" data-testid="privacy-page">
      <div className="mx-auto max-w-3xl px-6 py-14">
        <div className="flex items-center justify-between">
          <BrandLogo />
          <Link to="/login" data-testid="privacy-back-link" className="text-sm font-semibold text-indigo-300 hover:underline">
            Επιστροφή στη Σύνδεση
          </Link>
        </div>

        <h1 className="mt-10 font-display text-4xl sm:text-5xl font-black uppercase leading-[0.95] text-slate-50">
          Πολιτική Απορρήτου
        </h1>
        <p className="mt-3 text-xs uppercase tracking-[0.3em] text-emerald-400">Τελευταία ενημέρωση: {UPDATED}</p>

        <p className="mt-8 text-sm leading-relaxed text-slate-300">
          Η παρούσα Πολιτική Απορρήτου εξηγεί ποια δεδομένα συλλέγει η εφαρμογή NBACUBE, πώς τα
          χρησιμοποιεί και ποια δικαιώματα έχεις. Χρησιμοποιώντας την εφαρμογή, συμφωνείς με τα παρακάτω.
        </p>

        <Section title="Τι δεδομένα συλλέγουμε">
          <p>Όταν δημιουργείς λογαριασμό ή συνδέεσαι, μπορεί να συλλέξουμε:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Όνομα και διεύθυνση email.</li>
            <li>Εικόνα προφίλ (αν συνδεθείς με Google ή Facebook).</li>
            <li>Βασικά στοιχεία λογαριασμού και προτιμήσεις μέσα στην εφαρμογή.</li>
          </ul>
        </Section>

        <Section title="Σύνδεση μέσω τρίτων (Google / Facebook)">
          <p>
            Αν επιλέξεις να συνδεθείς με Google ή Facebook, λαμβάνουμε από τον πάροχο μόνο το όνομα,
            το email και τη δημόσια εικόνα προφίλ σου, ώστε να δημιουργήσουμε ή να εντοπίσουμε τον
            λογαριασμό σου. Δεν δημοσιεύουμε τίποτα στο προφίλ σου και δεν αποκτούμε πρόσβαση σε
            φίλους, αναρτήσεις ή άλλα δεδομένα.
          </p>
        </Section>

        <Section title="Πώς χρησιμοποιούμε τα δεδομένα">
          <ul className="list-disc pl-5 space-y-1">
            <li>Για να σε ταυτοποιούμε και να διατηρούμε τη συνεδρία σου.</li>
            <li>Για να σου παρέχουμε τις λειτουργίες και τις προβλέψεις της εφαρμογής.</li>
            <li>Για να επικοινωνούμε μαζί σου σχετικά με τον λογαριασμό σου (π.χ. email καλωσορίσματος).</li>
          </ul>
          <p>Δεν πουλάμε τα προσωπικά σου δεδομένα σε τρίτους.</p>
        </Section>

        <Section title="Διατήρηση & ασφάλεια">
          <p>
            Διατηρούμε τα δεδομένα σου όσο ο λογαριασμός σου είναι ενεργός. Οι κωδικοί αποθηκεύονται
            κρυπτογραφημένοι και η πρόσβαση γίνεται μέσω ασφαλών, κρυπτογραφημένων συνδέσεων.
          </p>
        </Section>

        <Section title="Διαγραφή δεδομένων">
          <p>
            Μπορείς να ζητήσεις τη διαγραφή του λογαριασμού και των δεδομένων σου οποιαδήποτε στιγμή,
            στέλνοντας email στο{" "}
            <a href={`mailto:${CONTACT}`} className="text-indigo-300 hover:underline">{CONTACT}</a>. Θα
            διαγράψουμε τα προσωπικά σου στοιχεία εντός εύλογου χρονικού διαστήματος.
          </p>
        </Section>

        <Section title="Επικοινωνία">
          <p>
            Για οποιαδήποτε ερώτηση σχετικά με το απόρρητο, επικοινώνησε στο{" "}
            <a href={`mailto:${CONTACT}`} className="text-indigo-300 hover:underline">{CONTACT}</a>.
          </p>
        </Section>

        <p className="mt-12 text-xs text-slate-500">© {new Date().getFullYear()} NBACUBE. Με επιφύλαξη παντός δικαιώματος.</p>
      </div>
    </div>
  );
}
